<template>
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g class="fill-current">
                <path d="M10.5,20 L5.5,20 L0,20 L0,7 L5,10.3333333 L5,7 L10,10.3333333 L10,7 L15,10.3333333 L15,0 L20,0 L20,20 L15.5,20 L10.5,20 Z" id="Combined-Shape"></path>
            </g>
        </g>
    </svg>
</template>
